<div
  [ngStyle]="{ background: 'url(assets/images/MarsChuteBanner.png)' }"
  class="content-header"
>
  <span class="header-title">MARS Gallery</span>
</div>
<p>gallery works!</p>
